module.exports = __webpack_public_path__ + "static/media/p0_4.7bf7bab0.png";